import { useQuery } from 'react-query';
import { filterObjectByRole } from 'utils/docs';

const fetchNotionData = async ({ queryKey }) => {
  const [_, url] = queryKey; // Extracts URL from query key
  if (!url) throw new Error('Invalid URL');

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch data : Status ${response.statusText || response.status}`);
  }

  return response.json();
};

const useNotionData = (url, role = 'none') => {
  const { data, isLoading, error } = useQuery(
    ['notionData', url], // Unique query key to prevent redundant requests
    fetchNotionData,
    {
      enabled: !!url, // Only fetch if the URL is valid
      keepPreviousData: true, // Keeps previous data while fetching new data (avoids flickering)
      retry: 2, // Retries failed requests up to 2 times
      refetchOnWindowFocus: false, // Prevents automatic refetching on window focus
    },
  );

  return {
    data: data ? filterObjectByRole(data, role) : null,
    loading: isLoading,
    error,
  };
};

export default useNotionData;
